<template>
  <v-dialog v-model="show" width="30vw" scrollable persistent>
    <v-card height="auto" elevation="5" class="rounded-xl" min-height="200">
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <span class="text-h5 black--text"> Historial de merma </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                :items="historyList"
                return-object
                outlined
                dense
                clearable
                item-text="name"
                no-data-text="No hay merma"
                label="Merma"
                v-model="bagSelected"
              >
                <template v-slot:item="data">
                  <div class="caption">
                    <div>
                      {{ data.item.name }} -
                      {{ data.item.reasonForContamination.text }}
                    </div>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" v-if="bagSelected">
              <span class="black--text font-weight-bold">
                Razón de merma:
                {{ bagSelected.reasonForContamination.text }}
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span class="text-h5 black--text"> Agregar merma </span>
            </v-col>
          </v-row>
          <v-form ref="strainForm" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="depletedBag"
                  outlined
                  dense
                  clearable
                  type="number"
                  label="Introduce número de bolsas a descartar"
                  :rules="validation()"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-combobox
                  outlined
                  dense
                  return-object
                  item-text="text"
                  label="Selecciona motivo de contaminación"
                  :items="contaminations"
                  v-model="contamination"
                  :rules="validation()"
                >
                </v-combobox>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="red"
                block
                rounded
                @click="closeModal"
                dark
                :disabled="isLoading"
                >Cancelar</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                block
                rounded
                @click="addWaste"
                :loading="isLoading"
                :disabled="loteSelected.isDoneInoculation"
                >Aceptar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapState, mapMutations } from "vuex";
//validations
import { requiredValidation } from "@/helpers/validations.js";
export default {
  data: () => ({
    bagSelected: null,
    wasteList: [],
    historyList: [],
    bagsAux: [],
    isLoading: false,
    contaminations: [
      { text: "Bacterias", value: "bacteria" },
      { text: "Hongo", value: "fungi" },
      { text: "Oxidación", value: "oxidation" },
      { text: "Sin crecimiento o poco", value: "no_growth" },
    ],
    contamination: null,
    user: JSON.parse(localStorage.getItem("user")),
    depletedBag: null,
  }),
  props: {
    value: Boolean,
    bags: Array,
  },
  computed: {
    ...mapState("lotes", ["loteSelected"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  methods: {
    ...mapActions("lotes", ["addBagWaste"]),
    ...mapMutations("lotes", ["SET_LOTE_SELECTED", "SET_FETCH_LOTES_LIST"]),
    ...mapMutations(["SET_CANCEL_TOKEN"]),
    async addWaste() {
      if (this.$refs.strainForm.validate()) {
        try {
          this.isLoading = true;
          let response = await this.addBagWaste({
            loteId: this.loteSelected._id,
            depletedBag: this.depletedBag,
            name: `Bolsas descartadas - ${this.depletedBag}`,
            contamination: this.contamination,
            user: this.user._id,
          });
          if (response) {
            if (!response.error) {
              this.depletedBag = null;
              this.contamination = null;
              this.$refs.strainForm.resetValidation();
              this.SET_LOTE_SELECTED(response.lote);
              this.SET_FETCH_LOTES_LIST(true);
              this.$swal({
                icon: "success",
                title: `Se agrego merma !!`,
                showConfirmButton: false,
                timer: 2000,
              });
              this.closeModal();
            } else {
              this.showErrotMessage();
            }
          } else {
            this.showErrotMessage();
          }
        } catch (e) {
          console.log(e);
          this.showErrotMessage();
        }
        this.isLoading = false;
      }
    },
    validation(name) {
      return requiredValidation(name);
    },
    showErrotMessage() {
      this.$swal({
        icon: "error",
        title: `Algo salio mal al agregar merma`,
        showConfirmButton: false,
        timer: 2000,
      });
    },
    closeModal() {
      this.show = false;
      this.wasteList = [];
    },
    getReason(reason) {
      let aux = this.contaminations.find((element) => element.value == reason);
      return aux ? aux.text : "No hay motivo";
    },
  },
  watch: {
    show(value) {
      if (value) {
        this.historyList = this.bags;
      } else {
        // CLOSE MODAL
      }
    },
  },
  destroyed() {
    this.wasteList = [];
  },
};
</script>
